import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

// Quand une requête est faite avec responseType: 'blob' (ex. téléchargement de fichier),
// Angular renvoie aussi le corps d'une réponse d'erreur JSON sous forme de Blob (err.error)
// au lieu de l'objet parsé. Les autres interceptors (DomainError, NetcoreError, ...) ne
// peuvent alors pas lire err.error.message / err.error.isDomainError. Cet interceptor
// reconvertit ce Blob JSON en objet avant que les interceptors suivants ne l'analysent.
@Injectable({
  providedIn: 'root',
})
export class BlobErrorInterceptorService implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.error instanceof Blob && err.error.type?.includes('json')) {
          return from(err.error.text()).pipe(
            mergeMap(text => {
              let parsedError: any = null;
              try {
                parsedError = JSON.parse(text);
              } catch {
                parsedError = null;
              }
              return throwError(new HttpErrorResponse({
                error: parsedError,
                headers: err.headers,
                status: err.status,
                statusText: err.statusText,
                url: err.url,
              }));
            }),
          );
        }
        return throwError(err);
      }),
    );
  }
}
